import { BehaviorSubject } from "rxjs";
import { FormControlOptionsMap, IControl, LControlType } from "../../types";
import { SSAutocompleteOptions } from "../ss-autocomplete-options";
import { SSCheckboxOptions } from "../ss-checkbox-options";
import { SSChecklistOptions } from "../ss-checklist-options";
import { SSDateOptions } from "../ss-date-options";
import { SSEmailOptions } from "../ss-email-options";
import { SSMultiAutocompleteOptions } from "../ss-multi-autocomplete-options";
import { SSPaswordOptions } from "../ss-password-options";
import { SSPhoneOptions } from "../ss-phone-options";
import { SSSelectOptions } from "../ss-select-options";
import { SSSliderOptions } from "../ss-slider-options";
import { SSTextAreaOptions } from "../ss-text-area-options";
import { SSTextOptions } from "../ss-text-options";
import { ClassControlOptionsMap } from "../types/class-control-options-map";
export class FormControlOptionsUtils {

  static initMappedObject<TControlType extends LControlType = LControlType>(classInstance: ClassControlOptionsMap[TControlType], options?: FormControlOptionsMap[TControlType]) {

    if (!options) {
      return;
    }

    Object
      .entries(options)
      .forEach(([optionName, optionValue]) => {

        const optionSubject = (classInstance as any)[optionName + 'Subject'] as BehaviorSubject<any>;


        if (!optionSubject || !(optionSubject instanceof BehaviorSubject)) {
          throw { message: 'No subject for an option(ss-form-control)' }
        }

        optionSubject.next(optionValue);
      })
  }


  static instantiateOptions<TControlType extends LControlType = LControlType>(control: IControl<TControlType>) {


    const instantiateByType: { [K in LControlType]: (control: IControl<K>) => ClassControlOptionsMap[K] } = {

      autocomplete: (control) => new SSAutocompleteOptions(control.options),
      checkbox: (control) => new SSCheckboxOptions(control.options),
      email: (control) => new SSEmailOptions(control.options),
      phone: (control) => new SSPhoneOptions(control.options),
      select: (control) => new SSSelectOptions(control.options),
      text: (control) => new SSTextOptions(control.options),
      password: (control) => new SSPaswordOptions(control.options),
      date: (control) => new SSDateOptions(control.options),
      slider: (control) => new SSSliderOptions(control.options),
      textarea: (control) => new SSTextAreaOptions(control.options),
      checklist: (control) => new SSChecklistOptions(control.options),
      multiautocomplete: (control) => new SSMultiAutocompleteOptions(control.options)
    }

    const byTypeInstantiator = instantiateByType[control.type] as (control: IControl<TControlType>) => ClassControlOptionsMap[TControlType];
    const instance = byTypeInstantiator && byTypeInstantiator(control)

    return instance;
  }
}
